import { createContext, useContext } from "react";
import { DEFAULT_TAGS } from "./lib/tags";

export const DEFAULT_SETTINGS = {
  thousands_separator: true,
  currency_symbol: false,
  label_mappings: [],
  tags: DEFAULT_TAGS,
  suppliers: [],
  employees: [],
};

export const SettingsContext = createContext({
  settings: DEFAULT_SETTINGS,
  openLabelMapping: () => {},
  addSupplier: () => {},
  addEmployee: () => {},
});

export const useSettings = () => useContext(SettingsContext);
